import React, { useState } from "react";
import { OwnProps } from "./types";
import {
  InlineBannerContainer,
  ImageContent,
  ImageWrapper,
  BannerImage,
  ContentWrapper,
  Title,
  Description,
  ButtonWrapper,
} from "./styles";
import { Button } from "../../atoms/Button";
import { sendGTMEvent } from "shared/services/GTM";
import { useSearchContext } from "shared/contexts/SearchContext";
import airportsData from "shared/config/airports/AllAirports/airports.json";

const InlineBanner: React.FC<OwnProps> = ({ inlineData }) => {
  const { searchState } = useSearchContext();
  const [failedImage, setFailedImage] = useState<string>();
  const showImage = inlineData.image && failedImage !== inlineData.image;

  function handleTriggerEvent() {
    const origin = searchState.origin?.code ?? "";
    const destination = searchState.destination?.code ?? "";
    try {
      sendGTMEvent("inline_click", {
        anunciante: inlineData.id ?? inlineData.title,
        IATA_origin: origin,
        IATA_destination: destination,
        IATA_route: `${origin}-${destination}`,
        country_origin:
          airportsData.find((airport) => airport.airport_code === origin)
            ?.country_code ?? "",
        country_destination:
          airportsData.find((airport) => airport.airport_code === destination)
            ?.country_code ?? "",
        departure_date: searchState.departureDates ?? [],
        return_date: searchState.returnDates ?? [],
      });
    } finally {
      window.open(inlineData.url, "_blank", "noopener,noreferrer");
    }
  }

  return (
    <InlineBannerContainer>
      <ImageContent>
        {showImage && (
          <ImageWrapper>
            <BannerImage
              src={inlineData.image}
              alt={inlineData.image_alt ?? inlineData.title}
              onError={() => setFailedImage(inlineData.image)}
            />
          </ImageWrapper>
        )}
        <ContentWrapper>
          <Title>{inlineData.title}</Title>
          {inlineData.description && (
            <Description>{inlineData.description}</Description>
          )}
        </ContentWrapper>
      </ImageContent>
      <ButtonWrapper>
        <Button
          label={inlineData.cta ?? "ver oferta"}
          uppercase
          onClick={handleTriggerEvent}
          backgroundColor="darkGreen"
          size="small"
          height={50}
        />
      </ButtonWrapper>
    </InlineBannerContainer>
  );
};

export default InlineBanner;
